import debug from 'debug';

function log(...value: unknown[]): void {
  debug('o365:lib:safeIgnore')('ignored function threw an error', ...value);
}

function nop() {
  /* deliberate */
}

/**
 * Chains on the given promise to safely ignore any result. Use to handle
 * fire-and-forget calls that failure can be ignored.
 * @arg promise: The promise to ignore.
 */
export function safeIgnore<T>(promise: () => Promise<T>): Promise<void> {
  try {
    return promise().then(nop, log);
  } catch (e) {
    log(e);
    return Promise.resolve();
  }
}
